// Icons
import {
  HouseLine,
  Coin,
  Receipt,
  ChartBar,
  Scroll,
  Money,
  Database,
  Warning,
  X,
  List,
} from "phosphor-react";

// Other
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

// Images
import LockedPattern from "../../../../Assets/Images/locked-pattern.png";

const Sidebar = () => {
  const location = useLocation();

  const [sidebarState, setSidebarState] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarState(!sidebarState);
  };

  useEffect(() => {
    const body = document.body;
    const originalBodyOverflow = body.style.overflow;

    if (sidebarState) {
      body.style.overflow = "hidden";
      body.addEventListener("touchmove", preventScrolling, { passive: false });
    } else {
      body.style.overflow = originalBodyOverflow;
      body.removeEventListener("touchmove", preventScrolling, {
        passive: false,
      });
    }

    return () => {
      body.style.overflow = originalBodyOverflow;
      body.removeEventListener("touchmove", preventScrolling, {
        passive: false,
      });
    };
  }, [sidebarState]);

  function preventScrolling(event) {
    event.preventDefault();
  }

  return (
    <aside
      className={`w-[10%] flex flex-col desktop:mr-2.5 z-10 noDesktop:h-[calc(100vh-30px)] sticky top-2 ${
        !sidebarState
          ? "text-center"
          : "noDesktop:bg-dark-700 noDesktop:w-[75%] noDesktop:absolute noDesktop:top-16"
      }`}
    >
      {/* Sidebar Toggle */}
      <section
        className={`desktop:hidden h-screen left-[-7px] font-semibold flex w-10 noDesktop:absolute justify-center
        ${
          sidebarState
            ? "noDesktop:hidden"
            : "noDesktop:visisble noDesktop:bg-dark-500 noDesktop:pt-2 opacity-50 rounded-tr-lg"
        }
        `}
      >
        <List
          size={27.5}
          className="text-brand-500"
          weight="bold"
          onClick={handleSidebarToggle}
        />
      </section>

      {/* Sidebar Content */}
      <section
        className={`noDesktop:h-screen noDesktop:overflow-scroll noDesktop:absolute ${
          sidebarState
            ? "noDesktop:visisble noDesktop:w-full noDesktop:pr-2 left-0"
            : "noDesktop:hidden"
        }`}
      >
        {/* In sidebar toggle */}
        <section
          className={`desktop:hidden font-semibold mb-3 flex items-center px-1 py-2 ${
            sidebarState ? "noDesktop:visisble " : "noDesktop:hidden"
          } `}
        >
          <X
            size={27.5}
            className="text-brand-500"
            weight="bold"
            onClick={handleSidebarToggle}
          />
        </section>

        {/* Available */}
        <ul>
          <li>
            <Link
              to="/dashboard"
              className={
                "px-3 py-3.5 h-auto font-semibold mb-3 flex items-center" +
                " " +
                (location.pathname === "/dashboard"
                  ? "bg-dark-500 rounded-lg drop-shadow-lg"
                  : "opacity-50")
              }
              onClick={handleSidebarToggle}
            >
              <HouseLine
                size={27.5}
                className="text-brand-500 mr-2"
                weight="bold"
              />
              Dashboard
            </Link>
          </li>
          <li>
            <Link
              to="/dashboard/revenue"
              className={
                "px-3 py-3.5 h-auto font-semibold mb-3 flex items-center" +
                " " +
                (location.pathname === "/dashboard/revenue"
                  ? " bg-dark-500 rounded-lg drop-shadow-lg"
                  : "opacity-50")
              }
              onClick={handleSidebarToggle}
            >
              <Coin size={27.5} className="text-brand-500 mr-2" weight="bold" />
              Revenue
            </Link>
          </li>

          <li>
            <Link
              to="/dashboard/expenses"
              className={
                "px-3 py-3.5 h-auto font-semibold mb-3 flex items-center" +
                " " +
                (location.pathname === "/dashboard/expenses"
                  ? " bg-dark-500 rounded-lg drop-shadow-lg"
                  : "opacity-50")
              }
              onClick={handleSidebarToggle}
            >
              <Receipt
                size={27.5}
                className="text-brand-500 mr-2"
                weight="bold"
              />
              Expenses
            </Link>
          </li>
        </ul>

        {/* Coming Soon */}
        <section
          className="rounded-lg relative overflow-hidden select-none flex cursor-pointer"
          data-tooltip-target="tooltip-default"
        >
          {/* Locked Image */}
          <img
            src={LockedPattern}
            alt="Locked Pattern"
            className="absolute top-0 left-0 opacity-50"
          />

          <section>
            <li className="px-3 py-3.5 h-auto font-semibold mb-3 flex align-items opacity-25">
              <ChartBar
                size={27.5}
                className="text-brand-500 mr-2"
                weight="bold"
              />
              Analytics
            </li>

            <li className="px-3 py-3.5 h-auto font-semibold mb-3 flex align-items opacity-25">
              <Database
                size={27.5}
                className="text-brand-500 mr-2"
                weight="bold"
              />
              Savings
            </li>

            <li className="px-3 py-3.5 h-auto font-semibold mb-3 flex align-items opacity-25">
              <Scroll
                size={27.5}
                className="text-brand-500 mr-2"
                weight="bold"
              />
              Budget
            </li>

            <li className="px-3 py-3.5 h-auto font-semibold mb-3 flex align-items opacity-25">
              <Money
                size={27.5}
                className="text-brand-500 mr-2"
                weight="bold"
              />
              Bills
            </li>
          </section>
        </section>
        <section className="flex items-center mt-3 opacity-50 mb-16">
          <Warning size={20.5} className="text-brand-500 mr-1" weight="bold" />
          <span className="text-sm font-semibold ">Coming Soon*</span>
        </section>
      </section>
    </aside>
  );
};

export default Sidebar;
